export const reorder = <T extends { id: string; order: number }>(list: T[], startIndex: number, endIndex: number) => {
  const isAscedingReorder = endIndex > startIndex;
  const isDescedingReorder = startIndex > endIndex;

  const endItemOrder = list[endIndex].order;

  const preparedItemsForReorder = list.map((item, index) => {
    if (startIndex === index) {
      return { ...item, order: endItemOrder };
    }

    return item;
  });

  let reorderedItems;

  switch (true) {
    case isAscedingReorder: {
      reorderedItems = preparedItemsForReorder.map((item, index) => {
        const { order } = item;

        // * Need to decrease order for items are included in the range between end and start items.
        if (endIndex >= index && index > startIndex) {
          return { ...item, order: order - 1 };
        }

        return item;
      });

      break;
    }
    case isDescedingReorder: {
      reorderedItems = preparedItemsForReorder.map((item, index) => {
        const { order } = item;

        // * Need to increase order for items are included in the range between end and start items.
        if (endIndex <= index && index < startIndex) {
          return { ...item, order: order + 1 };
        }

        return item;
      });

      break;
    }
    default: {
      reorderedItems = preparedItemsForReorder;

      break;
    }
  }

  return reorderedItems.sort((firstItem, secondItem) => firstItem.order - secondItem.order);
};
